
import {
  // Dashboard,
  Settings,
  ManufacturersSettings,
  ContactFunctionsSettings,
  TermsOfDeliverySettings,
  TermsOfPaymentSettings,
  ContactPersonSettings,
  Customer,
  CustomerBranchOffice,
  CustomerBranchOfficeContact,
  CustomerBranchOfficeBankAccounts,
  Inquiry,
  InquiryPosition,
  InquirySupplierRequests,
  UserSettings,
  ManufacturerBranchOfficeSettings,
  Documents,
  SupplierOffers,
  SupplierOfferDeclines,
  SupplierOfferPositionDeclines,
  SupplierOfferPositions,
  Offer,
  OfferPosition,
  ProductSettings,
  VatSettings,
  PurchaseOrder,
  PurchaseOrderPosition,
  Procurement,
  ProcurementPosition,
  History,
  SupplierOrder,
  SupplierOrderProforma,
  SupplierOrderPosition,
  FollowUp,
  Invoice,
  InvoicePosition,
  SupplierOrderPositionReceived,
  Picking,
  PickingPosition,
  BrandConfiguration,
  BrandConfigurationCI,
  ProductListings
} from '../store/namespace-helper'

export const stateHelperMixin = {

  methods: {
    resetStateBeforeLeaveRoute () {
      // this.$store.dispatch(Dashboard.actions.resetState)
      this.$store.dispatch(Settings.actions.resetState)
      this.$store.dispatch(ManufacturersSettings.actions.resetState)
      this.$store.dispatch(ContactFunctionsSettings.actions.resetState)
      this.$store.dispatch(TermsOfDeliverySettings.actions.resetState)
      this.$store.dispatch(TermsOfPaymentSettings.actions.resetState)
      this.$store.dispatch(ContactPersonSettings.actions.resetState)
      this.$store.dispatch(Customer.actions.resetState)
      this.$store.dispatch(CustomerBranchOffice.actions.resetState)
      this.$store.dispatch(CustomerBranchOfficeContact.actions.resetState)
      this.$store.dispatch(CustomerBranchOfficeBankAccounts.actions.resetState)
      this.$store.dispatch(Inquiry.actions.resetState)
      this.$store.dispatch(InquiryPosition.actions.resetState)
      this.$store.dispatch(InquirySupplierRequests.actions.resetState)
      this.$store.dispatch(UserSettings.actions.resetState)
      this.$store.dispatch(ManufacturerBranchOfficeSettings.actions.resetState)
      this.$store.dispatch(Documents.actions.resetState)
      this.$store.dispatch(SupplierOffers.actions.resetState)
      this.$store.dispatch(SupplierOfferDeclines.actions.resetState)
      this.$store.dispatch(SupplierOfferPositionDeclines.actions.resetState)
      this.$store.dispatch(SupplierOfferPositions.actions.resetState)
      this.$store.dispatch(Offer.actions.resetState)
      this.$store.dispatch(OfferPosition.actions.resetState)
      this.$store.dispatch(ProductSettings.actions.resetState)
      this.$store.dispatch(VatSettings.actions.resetState)
      this.$store.dispatch(PurchaseOrder.actions.resetState)
      this.$store.dispatch(PurchaseOrderPosition.actions.resetState)
      this.$store.dispatch(Procurement.actions.resetState)
      this.$store.dispatch(ProcurementPosition.actions.resetState)
      this.$store.dispatch(History.actions.resetState)
      this.$store.dispatch(SupplierOrder.actions.resetState)
      this.$store.dispatch(SupplierOrderProforma.actions.resetState)
      this.$store.dispatch(SupplierOrderPosition.actions.resetState)
      this.$store.dispatch(FollowUp.actions.resetState)
      this.$store.dispatch(Invoice.actions.resetState)
      this.$store.dispatch(InvoicePosition.actions.resetState)
      this.$store.dispatch(SupplierOrderPositionReceived.actions.resetState)
      this.$store.dispatch(Picking.actions.resetState)
      this.$store.dispatch(PickingPosition.actions.resetState)
      this.$store.dispatch(BrandConfiguration.actions.resetState)
      this.$store.dispatch(BrandConfigurationCI.actions.resetState)
      this.$store.dispatch(ProductListings.actions.resetState)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/stateHelperMixin.js